export default function(to, from, next) {
    if(!localStorage.getItem('isAuth') || !localStorage.getItem('token')) {
        next('/?page=login&AccessDenied=true')
    } else {
        next()
    }
}